import dayjs from 'Utilities/dayjs';

export type TransportPricingValue = {
	fixedCost: number;
	perMileCost: number;
	transportType: string;
};

export const PRICING_DATA_PREDECESSOR: TransportPricingValue[] = [
	{ fixedCost: 99, perMileCost: 0.95, transportType: 'Driven' },
	{ fixedCost: 160, perMileCost: 2.15, transportType: 'Transported' },
	{ fixedCost: 170, perMileCost: 2.25, transportType: 'Heavy transported' },
];

export const PRICING_DATA_SUCCESSOR: TransportPricingValue[] = [
	{ fixedCost: 110, perMileCost: 0.95, transportType: 'Driven' },
	{ fixedCost: 180, perMileCost: 2.25, transportType: 'Transported' },
	{ fixedCost: 180, perMileCost: 2.25, transportType: 'Heavy transported' },
];

const PRICING_CUTOVER_DATE = dayjs.utc('2026-01-01T00:00:00Z');

export const resolveTransportPricing = (): TransportPricingValue[] => {
	const now = dayjs.utc();
	const isPastCutover = now.isSame(PRICING_CUTOVER_DATE) || now.isAfter(PRICING_CUTOVER_DATE);

	return isPastCutover ? PRICING_DATA_SUCCESSOR : PRICING_DATA_PREDECESSOR;
};
